import React, {useState} from "react";
import {Tooltip} from "react-tippy";
import CheckBox from "../../../../form/CheckBox";
import {CurrencyFormatter, ProductColumn, UnitFormatter} from "../../../../../utils/formatters";
import SelectorGrid from "../../../../form/SelectorGrid/SelectorGrid";
import Portal from "../../../../layout/Portal";
import Modal from "../../../../layout/Modal";
import classNames from "classnames";
import Icon from "../../../../form/Icon";

const Actions = (propsTop) => {
    const [deleting, setDeleting] = useState(false);
    const [loading, setLoading] = useState(false);
    return <div>
        {deleting && <Portal>
            <Modal
                header="Törlés"
                state="on"
                buttons={[
                    {
                        text: "Törlés",
                        props: {
                            color: "danger",
                            disabled: propsTop.props.disabled || propsTop.props.loading || loading
                        },
                        onClick: async (e) => {
                            if (propsTop.props.disabled || propsTop.props.loading || loading) return;
                            e && e.preventDefault();
                            setLoading(true);
                            await propsTop.onItemRemove(propsTop.item);
                            setDeleting(false);
                            setLoading(false);
                        }
                    },
                    {
                        text: "Mégse",
                        props: {
                            color: "default",
                            disabled: propsTop.props.disabled || propsTop.props.isLoading || loading
                        },
                        onClose: true,
                        onClick: async () => {
                            try {
                                setDeleting(false);
                                setLoading(false);
                            } catch (e) {

                            }
                        }
                    }
                ]}
            >
                Biztosan törlöd ezt a tételt?
            </Modal>
        </Portal>}
        <span className={classNames("btn btn-danger btn-xs", {disabled: propsTop.props.disabled || propsTop.props.loading || loading})} onClick={() => {
            if (propsTop.props.disabled || propsTop.props.loading || loading) return;
            setDeleting(true);
        }}><Icon lib="fa" name="trash"/></span>
    </div>
}

const sortable = true;
const filterable = true;

export default class Items extends React.Component {

    state = {
        filtered: true
    }

    refresh = () => {
        this.items.refresh();
    }

    refreshBackground = () => {
        this.items.refreshBackground();
    }

    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, actionButtons} = props;
        return (
            <SelectorGrid
                ref={(e) => this.items = e}
                className={"p-small-table"}
                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", params: {name: ((props.values.label ? props.values.label + " - " : "") + (this.state.filtered ? "Csak a saját tételeim (" + this.props.user.name + ")" : "Minden tétel"))}}]}
                view={["id", "name", "qty", "component_id", "created_by", "vat"]}
                filter={this.state.filtered ? [{field: "created_by", value: this.props.user.id, operator: "="}] : []}
                paginatorRight={() => <Tooltip title={!this.state.filtered ? "Csak az általam leltárazott tételek mutasd" : "Mindent mutat"}><CheckBox
                    onIcon={{lib: "fas", name: "walking"}}
                    offIcon={{lib: "fas", name: "people-carry"}}
                    value={this.state.filtered}
                    label={false}
                    saveChanges={(field, value) => {
                        this.setState({filtered: !!value});
                    }}
                /></Tooltip>}
                pageSize={50}
                pageSizes={[5,10,15,50]}
                columns={{
                    "displayname": {
                        ...ProductColumn("component_id"),
                        width: !this.state.filtered ? 6 : 7,
                    },
                    "barcode": {
                        header: 'Vonalkód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "listprice": {
                        header: 'Lista ár',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: CurrencyFormatter,
                        className: "currency"
                    },
                    "qty": {
                        header: 'Darabszám',
                        width: 1,
                        sortable,
                        filterable,
                        aggregation: (value, row) => UnitFormatter(value || 0, row.unit),
                        className: "unit",
                        renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                    },
                    "created_at": {
                        header: 'Idő',
                        width: 2,
                        sortable,
                        filterable,
                    },
                    ...(!this.state.filtered ? {
                        "created_by.name": {
                            header: 'Rögzítette',
                            width: 1,
                            sortable,
                            filterable
                        }
                    } : {}),
                    "actions": {
                        header: ' ',
                        renderer: (value, row) => {
                            return <Actions this={this} props={this.props} state={this.state} item={row} onItemRemove={async () => {
                                const item = {...row};
                                item.qty = null;
                                const componentProps = {...this.props};
                                const {parent} = componentProps;
                                await parent.onSourceItemUpdate(item, row, "qty");
                                this.items.refreshBackground();
                                this.props.removedItem && this.props.removedItem();
                            }} />
                        },
                    },
                }}
                rowClassName={(rowData) => {
                    const classes = {};
                    if (!this.state.filtered) {
                        classes["p-highlight"] = (rowData.created_by || {}).id + "" === "" + this.props.user.id;
                    }
                    return classes;
                }}
                aggregations={{
                    fields: {
                        "qty": {
                            field: "qty", type: "SUM"
                        },
                    }
                }}
                listfield="items"
                data={props.values}
                orderBy={{field: "created_at", direction: "DESC"}}
                sortBy={{field: "created_at", direction: "DESC"}}
                componentConfig={props.componentConfig}
            />
        )
    }
}